import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const SmallBox = ({
    type,
    icon = 'ion-bag',
    count,
    title,
    onClick,
    navigateTo
}) => {
    const {t} = useTranslation();

    let className = 'small-box';
    let iconClass = 'ion';
    switch (type) {
        case 'success':
            className += ' bg-gradient-success';
            break;
        case 'warning':
            className += ' bg-gradient-warning';
            break;
        case 'danger':
            className += ' bg-gradient-danger';
            break;
        case 'info':
            className += ' bg-gradient-info';
            break;
        default:
            className += ' bg-gradient-gray';
            break;
    }

    iconClass += icon ? ` ${icon}` : ' ion-bag';

    return (
        <div className={className}>
            <div className="inner">
                <h3 className='user-select-none'>{count}</h3>
                <p className='user-select-none'>{title}</p>
            </div>
            <div className="icon">
                <i className={iconClass} />
            </div>
            {
                navigateTo && navigateTo.length > 0 && (
                    <Link to={navigateTo} className="small-box-footer">
                        <span className="mr-2">{t('main.label.moreInfo')}</span>
                        <i className="fa fa-arrow-circle-right" />
                    </Link>
                )
            }
            {
                onClick !== null && (
                    <div className="small-box-footer" onClick={onClick} aria-hidden="true" role='button'>
                        <span className="mr-2 user-select-none">{t('main.label.moreInfo')}</span>
                        <i className="fa fa-arrow-circle-right" />
                    </div>
                )
            }
            
        </div>
    );
};

SmallBox.defaultProps = {
    onClick: null,
};

export default SmallBox;
